import { URL_LABEL } from "../../../../../content/index.content";

const productDatabase = ({ language, isSavedUser }) => {
  return {
    title: "Product Database",
    subtitle:
      "Filter Amazon products and quickly assess their supply, demand, competition, and more",
    href: isSavedUser
      ? `/app/#/database/?${URL_LABEL}`
      : `/product-database/?${URL_LABEL}`,
    isLink: !isSavedUser,
  };
};

export default productDatabase;
